import { Fragment } from "react"
import { Button } from "@mui/material"
import { Link } from "react-router-dom"

export default function Session() {
  return (
    <Fragment>
      <Button color="warning" component={Link} to="/" fullWidth>
        Back to Sessions
      </Button>
    </Fragment>
  )
}
